export const fnOrVal = (val, fn, ...args) => (fn ? fn(...args) : val)

export const comboboxInputID = 'autocomplete-0'
export const comboboxMenuID = 'autocomplete-1'
export const comboboxMenuItemID = 'autocomplete-2'
export const comboboxInputValueID = 'autocomplete-3'
export const comboboxInputValueRemoveID = 'autocomplete-4'

export interface ComboboxItem<T> {
  readonly name?: string
  readonly items: T[]
}
